import React from 'react';

interface PercentageInputProps {
  id?: string;
  label: string;
  value: number;
  onChange: (val: number) => void;
  hint?: string;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
}

export const PercentageInput: React.FC<PercentageInputProps> = ({
  id,
  label,
  value,
  onChange,
  hint,
  min = 0,
  max = 100,
  step = 0.1,
  className = '',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^0-9.]/g, '');
    const num = parseFloat(raw);
    if (!isNaN(num)) {
      onChange(Math.min(max, Math.max(min, num)));
    } else if (raw === '') {
      onChange(0);
    }
  };

  return (
    <div className={`space-y-1.5 ${className}`}>
      <div className="flex items-center justify-between">
        <label htmlFor={id} className="text-xs font-semibold text-[#1A1A1A] block">
          {label}
        </label>
        <span className="text-[10px] font-mono font-bold text-[#6B7280] bg-[#F3F4F6] px-1.5 py-0.5 rounded border border-[#E5E7EB]">
          % APR/Tax
        </span>
      </div>

      <div className="relative flex items-center">
        <input
          id={id}
          type="text"
          inputMode="decimal"
          value={value}
          onChange={handleChange}
          className="w-full pl-3.5 pr-8 py-2.5 bg-white border border-[#E5E7EB] hover:border-[#D1D5DB] focus:border-[#1A1A1A] focus:ring-1 focus:ring-[#1A1A1A] rounded-xl text-sm font-bold text-[#1A1A1A] font-mono transition-all outline-none"
        />
        <span className="absolute right-3.5 text-sm font-semibold text-[#6B7280] select-none">
          %
        </span>
      </div>

      {hint && (
        <p className="text-[11px] text-[#6B7280] leading-tight">{hint}</p>
      )}
    </div>
  );
};
